<script setup>
import Footer from '@/views/front-pages/front-page-footer.vue'
import Navbar from '@/views/front-pages/front-page-navbar.vue'
import { useI18n } from 'vue-i18n'
import axios from '@/helpers/axios'
import Map from '@/views/landing/groups/Map.vue'
import Devices from '@/views/landing/groups/Devices.vue'
import PublicGroupHeader from '@/views/landing/groups/PublicGroupHeader.vue'
import Webcams from '@/views/landing/groups/Webcams.vue'

definePage({
  meta: {
    layout: 'blank',
    public: true
  }
})

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const uuid = route.params.uuid
const group = ref(null)

const deviceCount = computed(() => group.value?.devices_count ?? 0)
const webcamCount = computed(() => {
  const webcams = group.value?.webcams
  return Array.isArray(webcams) ? webcams.length : webcams ?? 0
})

const hasMapContent = computed(() => deviceCount.value > 0 || webcamCount.value > 0)
const webcamsList = computed(() => Array.isArray(group.value?.webcams) ? group.value.webcams : [])

const getData = () => {
  axios.get('/landing/groups/' + uuid).then(response => {
    group.value = response.data
  }).catch(e => {
    if (e.response.status === 404) {
      router.replace('/')
    }
    console.error(e)
  })
}

getData()
</script>

<template>
  <div class="public-group-page">
    <Navbar />
    <div v-if="group" class="public-group-wrapper">
      <VContainer class="py-12">
        <PublicGroupHeader
          :group="group"
          class="mb-6 mt-12"
        />

        <Map
          v-if="hasMapContent"
          :group="group"
        />

        <VRow class="mt-4">
          <VCol cols="12">
            <Devices :devices="group.devices || []" />
          </VCol>
        </VRow>

        <Webcams
          v-if="webcamsList.length"
          :webcams="webcamsList"
          class="mt-6"
        />
      </VContainer>

      <Footer class="mt-6" />
    </div>
  </div>
</template>

<style scoped>
.public-group-page {
  background-color: var(--v-theme-surface);
  min-height: 100vh;
}

.public-group-wrapper {
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.02), transparent 30%);
}

@media (max-width: 960px) {
  .public-group-wrapper {
    padding-inline: 0.5rem;
  }
}
</style>
